var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-1"},[_c('label',[_vm._v("Wyszukaj etykietę ERP ze zleceń (szukanie pełne)")]),_c('sqler')],1)}
var staticRenderFns = []

export { render, staticRenderFns }